import React from 'react'
import ReactAudioPlayer from 'react-audio-player';

import LoadingScreen from './loadingScreen.component'
import Scene from './Scene.component'
import CarStudioUI from './carStudioUI.container'
//import ExitBtn from './exit.container'
import TopMenu from './topMenu.component'
import Collapse from './collapse.component'
import Drag from './drag.component'
import DragTablets from './dragTablets.component';
import PDFViewerMenu from './pdfViewerMenu.component';
import Billboards from './billboards.component';
import VideoText from './videoText.component';
import Quotation from './quotation.component';
import GETWebParams from '../../helpers/GETWebParams';

import { getConfigData } from '../../helpers/strapi.helper';
import Video from './video.component';

const params = GETWebParams()

interface CarStudioContainer {
  containerRef: any,
}

interface Props {
  openCarStudio: boolean,
  currentCarSelected: string,
  startOnInteriorView: boolean,
  isTouchScreen: boolean,
  handleCloseCarStudio: () => void
}

interface State {
  openLoadingScreen: boolean,
  openScene: boolean,
  turnOffLights: boolean,
  showLigths: boolean,
  showInteriorLights: boolean,
  counter: number,
  showDrag: boolean,
  showCollapse: boolean,
  showPDF: boolean,
  currentCompleteCar: string,
  currentModelSelected: string,
  currentColorSelected: string,
  currentLoadingPercentage: number,
  currentLoadingInteriorPercentage: number
  isLocale: boolean,
  showInterior: boolean,
  currentSeatSelected: string,
  interiorLoader: boolean
  exteriorLoader: boolean,
  isMuted: boolean,
  currentBillboardSelected: string,
  showBullets: boolean,
  currentSceneSelected: any,
  showBulletInterior: boolean ,
  showVideo: boolean,
  showVideoText: boolean,
  isVideoOpened: boolean,
  isPlayingAnimation: boolean,
  isTablet: boolean,
  isQuotationOpened: boolean,
  isCarStudioClosedQuotation: boolean,
  firstLoadedWebParams: boolean,
  enableInternalCotizaGlobally: boolean,
}

class CarStudioContainer extends React.Component<Props,State>{
  constructor(props: Props){
    super(props);
    this.state = {
      openLoadingScreen: false,
      openScene: false,
      turnOffLights: false,
      showLigths: false,
      showInteriorLights: false,
      counter: 0,
      showDrag: false,
      showCollapse: false,
      showPDF: false,
      currentCompleteCar: '',
      currentModelSelected: '',
      currentColorSelected: '',
      isLocale: false,
      currentLoadingPercentage: 0,
      currentLoadingInteriorPercentage: 0,
      showInterior: false,
      currentSeatSelected: 'FL',
      interiorLoader: false,
      exteriorLoader: false,
      isMuted: !getConfigData().sonido_activo,
      currentBillboardSelected: '',
      showBullets: false,
      currentSceneSelected: {},
      showBulletInterior: false,
      showVideo: false,
      showVideoText: false,
      isVideoOpened: false,
      isPlayingAnimation: false,
      isTablet: false,
      isQuotationOpened: false,
      isCarStudioClosedQuotation: false,
      firstLoadedWebParams: true,
      enableInternalCotizaGlobally: false,//enable cotiza form, if enabled, no external link will be opened.
    }

    this.containerRef = React.createRef()
  }

  componentDidMount(): void {
    if((navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 0) || navigator.platform === 'iPad' || navigator.userAgent.match(/iPad/i)){
      this.setState({
        isTablet: true
      })
    }
  }

  componentDidUpdate(prevProps: Readonly<Props>, prevState: Readonly<State>, snapshot?: any): void {
    if(this.props.openCarStudio !== prevProps.openCarStudio && this.props.openCarStudio){
      this.setState({
        openLoadingScreen: true
      })
    }
  }

  handleOpenScene = () => {
    this.setState({
      openLoadingScreen: false,
      openScene: true
    })
  }

  handleTurnOffLigths = (payload: boolean) => {
    this.setState({
      turnOffLights: payload
    })
  }

  handleShowLigths = (payload: boolean) => {
    this.setState({
      showLigths: payload
    })
  }

  handleShowInteriorLights = (payload: boolean) => {
    this.setState({
      showInteriorLights: payload
    })
  }


  handleCloseScene = () => {
    this.setState({
      openScene: false,
      isLocale: false,
      openLoadingScreen: false,
      turnOffLights: false,
      counter: 0,
      showDrag: false,
      showCollapse: false,
      showPDF: false,
      currentCompleteCar: '',
      currentModelSelected: '',
      currentColorSelected: '',
      currentLoadingPercentage: 0,
      currentLoadingInteriorPercentage: 0,
      showInterior: false,
      currentSeatSelected: 'FL',
      interiorLoader: false,
      exteriorLoader: false,
      isMuted: false,
      currentBillboardSelected: '',
      showBullets: false,
      currentSceneSelected: {},
      showBulletInterior: false,
      showVideo: false,
      isVideoOpened: false,
      isPlayingAnimation: false,
      isTablet: false,
      isQuotationOpened: false,
      isCarStudioClosedQuotation: false,
      firstLoadedWebParams: false
    }, () => {
      this.props.handleCloseCarStudio()
    })
  }

  handleFirstWebParams = (payload: boolean) => {
    this.setState({
      firstLoadedWebParams: payload
    })
  }

  handleCollapse = (payload: boolean) => {
    this.setState({
      showCollapse: payload
    })
  }

  handleShowPDF = (payload: boolean) => {
    this.setState({
      showPDF: payload
    })
  }

  handleCloseDrag = () => {
    this.setState({
      showDrag: false
    })
  }

  handleOpenDrag = () => {
    this.setState({
      showDrag: true
    })
  }

  handleCompleteCar = (payload: string) => {
    this.setState({
      currentCompleteCar: payload
    })
  }

  handleChangeColor = (payload: string) => {
    this.setState({
      currentColorSelected: payload
    })
  }

  handleIsLocale = () => {
    this.setState({
      isLocale: true
    })
  }

  handleGetLoadPercentage = (payload: number) => {
    this.setState({
      currentLoadingPercentage: payload
    })
  }

  handleShowInterior = (payload: boolean) => {
    this.setState({
      showInterior: payload
    })
  }

  handleChangeSeat = (payload: string) => {
    this.setState({
      currentSeatSelected: payload
    })
  }

  handleLoadInterior = (payload: number) => {
    this.setState({
      currentLoadingInteriorPercentage: payload
    })
  }

  handleExteriorLoader = () => {
    this.setState({
      exteriorLoader: true
    })
  }

  handleInteriorLoader = () => {
    this.setState({
      interiorLoader: true
    })
  }

  handleMuteSong = () => {
    this.setState({
      isMuted: !this.state.isMuted
    })
  }

  handleSelectBillboard = (payload: string) => {
    this.setState({
      currentBillboardSelected: payload
    })
  }

  handleShowBullets = (payload: boolean) => {
    this.setState({
      showBullets: payload
    })
  }

  handleShowBulletsInterior = (payload: boolean) => {
    this.setState({
      showBulletInterior: payload
    })
  }

  handleChangeScene = (payload: any) => {
    this.setState({
      currentSceneSelected: payload
    })
  }

  handleShowVideo = (payload: boolean) => {
    this.setState({
      showVideo: payload,
      showBulletInterior: false,
      showBullets: false,
      turnOffLights: false
    })
  }

  handleShowVideoText = (payload: boolean) => {
    this.setState({
      showVideoText: payload
    })
  }

  handleIsVideoOpened = (payload: boolean) => {
    this.setState({
      isVideoOpened: payload
    })
  }

  handleIsPlayingAnimation = (payload: boolean) => {
        this.setState({
      isPlayingAnimation: payload
    })
  }

  handleQuotation = (payload: boolean) => {
    this.setState({
      isQuotationOpened: payload
    })
  }

  handleCarStudioFromQuotation = (payload: boolean) => {
    this.setState({
      isCarStudioClosedQuotation: payload
    })
  }

  handleSelectModel = (payload: string) => {
    this.setState({
      currentModelSelected: payload
    })
  }
  
  render(): React.ReactNode {
      return(
        <div className={this.props.openCarStudio ? 'car-studio-general-container fade-in':'car-studio-general-container fade-out'} id="container">
          {this.state.openScene && params.lite !== "true" && getConfigData().sonido_activo ?
            <ReactAudioPlayer
              src={getConfigData().musica_ambiente || require('./../../UI/Music/song.mp3').default}
              autoPlay
              controls={false}
              loop
              muted={this.state.isMuted}
              id={"song"}
              volume={1}
            />:null
          }
          {
            this.props.openCarStudio ?
            <Scene
              handleOpenScene = {this.handleOpenScene} 
              startOnInteriorView= {this.props.startOnInteriorView}
              openScene = {this.state.openScene}
              turnOffLights = {this.state.turnOffLights}
              ref = {this.containerRef}
              handleCloseDrag = {this.handleCloseDrag}
              counter={this.state.counter}
              currentCompleteCar = {this.state.currentCompleteCar}
              currentColorSelected = {this.state.currentColorSelected}
              isLocale = {this.state.isLocale}
              handleIsLocale = {this.handleIsLocale}
              handleGetLoadPercentage = {this.handleGetLoadPercentage}
              showInterior = {this.state.showInterior}
              currentSeatSelected = {this.state.currentSeatSelected}
              handleLoadInterior = {this.handleLoadInterior}
              handleSelectBillboard = {this.handleSelectBillboard}
              showBullets = {this.state.showBullets}
              currentSceneSelected = {this.state.currentSceneSelected}
              showBulletsInterior = {this.state.showBulletInterior}
              showVideo = {this.state.showVideo}
              handleShowVideo = {this.handleShowVideo}
              handleShowVideoText = {this.handleShowVideoText}
              handleOpenDrag = {this.handleOpenDrag}
              handleIsPlayingAnimation = {this.handleIsPlayingAnimation}
              isPlayingAnimation = {this.state.isPlayingAnimation}
              showLigths = {this.state.showLigths}
              showInteriorLights = {this.state.showInteriorLights}
              handleShowLigths = {this.handleShowLigths}
              handleShowInteriorLights = {this.handleShowInteriorLights}
              isTouchScreen = {this.props.isTouchScreen}
            />:null
          }
          {
            this.props.openCarStudio ?
            <CarStudioUI
              openScene = {this.state.openScene}
              currentCarSelected={this.props.currentCarSelected}
              handleTurnOffLigths = {this.handleTurnOffLigths}
              handleCompleteCar={this.handleCompleteCar}
              handleChangeColor = {this.handleChangeColor}
              handleShowInterior = {this.handleShowInterior}
              handleChangeSeat = {this.handleChangeSeat}
              handleShowBullets = {this.handleShowBullets}
              handleChangeScene = {this.handleChangeScene}
              handleShowBulletsInterior = {this.handleShowBulletsInterior}
              handleShowVideo = {this.handleShowVideo}
              showVideo = {this.state.showVideo}
              handleIsVideoOpened = {this.handleIsVideoOpened}
              handleIsPlayingAnimation={this.handleIsPlayingAnimation}
              isPlayingAnimation = {this.state.isPlayingAnimation}
              handleCloseCarStudio = {this.handleCloseScene}
              handleSelectModel = {this.handleSelectModel}
              handleQuotation = {this.handleQuotation}
              isQuotationOpened = {this.state.isQuotationOpened}
              showLigths = {this.state.showLigths}
              showInteriorLights = {this.state.showInteriorLights}
              handleShowLigths = {this.handleShowLigths}
              handleShowInteriorLights = {this.handleShowInteriorLights}
              handleCollapse = {this.handleCollapse}
              handleCarStudioFromQuotation = {this.handleCarStudioFromQuotation}
              isCarStudioClosedQuotation = {this.state.isCarStudioClosedQuotation}
              handleShowPDF = {this.handleShowPDF}
              firstLoadedWebParams = {this.state.firstLoadedWebParams}
              handleFirstWebParams = {this.handleFirstWebParams}
              enableInternalCotizaGlobally = {this.state.enableInternalCotizaGlobally}
            />:null
          }
          {/*
            <ExitBtn
            openScene = {this.state.openScene}
            handleCloseCarStudio = {this.handleCloseScene}
          />
          */}
          {params.lite !== "true" &&
            <TopMenu
              openScene = {this.state.openScene}
              handleMuteSong = {this.handleMuteSong}
              isMuted = {this.state.isMuted}
              handleQuotation = {this.handleQuotation}
              isQuotationOpened = {this.state.isQuotationOpened}
              currentModel = {this.state.currentModelSelected}
              currentCompleteCar = {this.state.currentCompleteCar}
              enableInternalCotizaGlobally = {this.state.enableInternalCotizaGlobally}
              handleCloseCarStudio = {this.handleCloseScene}
            />
          }
          
          <Collapse
            openScene = {this.state.openScene}
            showCollapse = {this.state.showCollapse}
          />
          {!this.props.isTouchScreen ?
          <Drag
            openScene = {this.state.openScene}
            showDrag = {this.state.showDrag}
            isPortrait = {false}
          />:
          <DragTablets
            openScene = {this.state.openScene}
            showDrag = {this.state.showDrag}
            isPortrait = {false}
          />
          }
          {
            <PDFViewerMenu
              showPDF = {this.state.showPDF}
              handleShowPDF = {this.handleShowPDF}
              currentCarSelected={this.props.currentCarSelected}
              currentModelSelected = {this.state.currentModelSelected}
            />
          }
          {
            <Billboards
              currentCarSelected={this.props.currentCarSelected}
              currentBillboardSelected = {this.state.currentBillboardSelected}
              currentCompleteCar = {this.state.currentCompleteCar}
              handleSelectBillboard = {this.handleSelectBillboard}
            />
          }
          {
            <Video
              isVideoOpened =  {this.state.isVideoOpened}
              completeCar={this.state.currentCompleteCar}
              handleIsVideoOpened = {this.handleIsVideoOpened}
            />
          }
          {this.state.showVideo ?
            <VideoText
              isVideoOpened = {this.state.showVideo && this.state.showVideoText}
              currentCompleteCar={this.state.currentCompleteCar}
              handleShowVideo = {this.handleShowVideo}
            />:null
          }
          {
            <Quotation
              isQuotationOpened = {this.state.isQuotationOpened}
              currentCarSelected={this.props.currentCarSelected}
              currentModelSelected = {this.state.currentModelSelected}
              currentColorSelected={this.state.currentColorSelected}
              handleQuotation = {this.handleQuotation}
              handleCarStudioFromQuotation = {this.handleCarStudioFromQuotation}
            />
          }
          {
            this.state.openLoadingScreen && this.props.openCarStudio ?
            <LoadingScreen
              handleOpenScene = {this.handleOpenScene} 
              openLoadingScreen = {this.state.openLoadingScreen}
              isLocale = {this.state.isLocale}
              currentLoadingPercentage={this.state.currentLoadingPercentage}
              currentLoadingInteriorPercentage = {this.state.currentLoadingInteriorPercentage}
            />:null
          }
          
        </div>
      )
  }
}

export default CarStudioContainer